/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Adsense_DescriptionInputs */

const en_admin_settings_groups_adsense_description = /** @type {(inputs: Admin_Settings_Groups_Adsense_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inject the AdSense script sitewide and serve /ads.txt from the configured publisher ID`)
};

/**
* | output |
* | --- |
* | "Inject the AdSense script sitewide and serve /ads.txt from the configured publisher ID" |
*
* @param {Admin_Settings_Groups_Adsense_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_adsense_description = /** @type {((inputs?: Admin_Settings_Groups_Adsense_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Adsense_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_adsense_description(inputs)
});
export { admin_settings_groups_adsense_description as "admin.settings.groups.adsense.description" }